import moment from 'moment';
import fetchRDFoxData from './RDFoxRequest';

export interface DecompositionResidualData {
    id: string;
    TimeWindow: Date;
    resid: number;
}

const getDataDecompositionResidual = async (): Promise<DecompositionResidualData[]> => {
    const query = `
        PREFIX rdf: <https://rdfox.com/getting-started/>
        
        SELECT ?id ?time ?resid
        WHERE {
            ?id rdf:TimeWindow ?time ;
                rdf:resid ?resid .
            FILTER (?resid != "")
        }
        ORDER BY ?time
    `;

    try {
        console.log('Executing SPARQL query:', query);
        const response = await fetchRDFoxData('decomposition_residual', query);
        console.log('SPARQL response:', response);
        
        if (!response?.results?.bindings || response.results.bindings.length === 0) {
            console.warn('No data available in the response');
            return [];
        }
        
        const data = response.results.bindings
            .map((row: any) => {
                try {
                    const id = row.id.value.split('/').pop() || '';
                    const timeStr = row.time.value;
                    const residStr = row.resid.value;
                    
                    // Parse time value using moment for better date parsing
                    const time = moment(timeStr, 'YYYY-MM-DD HH:mm:ss');
                    if (!time.isValid()) {
                        console.error('Invalid time value:', timeStr);
                        return null;
                    }
                    
                    // Parse resid value
                    const resid = parseFloat(residStr);
                    if (isNaN(resid)) {
                        console.error('Invalid resid value:', residStr);
                        return null;
                    }
                    
                    return {
                        id,
                        TimeWindow: time.toDate(),
                        resid
                    };
                } catch (err) {
                    console.error('Error parsing row:', row, err);
                    return null;
                }
            })
            .filter((item: DecompositionResidualData | null): item is DecompositionResidualData => item !== null);
        
        console.log('Parsed data:', data);
        return data;
        
    } catch (error) {
        console.error('Error fetching decomposition residual data:', error);
        throw new Error('Failed to fetch data from RDFox: ' + (error instanceof Error ? error.message : String(error)));
    }
};

export default getDataDecompositionResidual;
